import React from "react";
// import moment from "moment-timezone";
// import SearchIcon from "@mui/icons-material/Search";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { ReactComponent as VisaCardIcon } from '../../icons/visaCardIcon.svg';
import { ReactComponent as MasterCardIcon } from '../../icons/masterCardIcon.svg';
import { ReactComponent as AmexCardIcon } from '../../icons/amexCardIcon.svg';
import { ReactComponent as DiscoverCardIcon } from '../../icons/discoverCard.svg';
import { ReactComponent as CashappIcon } from '../../icons/cashappIcon.svg';
import { ReactComponent as AmazonPayIcon } from '../../icons/AmazonPayIcon.svg';
import { PaymentHistoryItemSchema } from '../../data/types';
// import { PaymentMethod } from "@stripe/stripe-js";
import { 
  // capitalizeString, formatDateString,
   styleThousandCommas, getPaymentStatusColor, formatDateString } from "../../utils/helpers";
// import moment from "moment";
// import { useGetPaymentMethods } from "../hooks/paymenthooks";
// import { useCompleteSignIn } from "../hooks/authhooks";
  // import Pagination from "../components/Pagination";


type PaymentHistoryRecordProps = {
  paymentHistoryItem: PaymentHistoryItemSchema;
}

const PaymentHistoryRecord: React.FC<PaymentHistoryRecordProps> = ({ paymentHistoryItem }) => {
  // const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 10;
  // const totalPages = Math.ceil(paymentHistoryList.length / itemsPerPage);
  // const startIndex: number = (currentPage - 1) * itemsPerPage;
  // const endIndex: number = Math.min(startIndex + itemsPerPage, paymentHistoryList.length);
  // const currentPaymentHistoryList = paymentHistoryList.slice(startIndex, endIndex);

  // console.log("currentPaymentHistoryList: ", currentPaymentHistoryList)


  // const { user } = useCompleteSignIn();
  // const loggedinUid = (user && user?.uid) ? user.uid : '';
  // console.log("loggedinUid: ", loggedinUid)


  const getCardIcon = (paymentMethod: string) => {
    switch (paymentMethod) {
      case 'visa':
        return <VisaCardIcon className='w-8 my-auto' />;
      case 'mastercard':
        return <MasterCardIcon className='w-8 my-auto' />;
      case 'amex':
        return <AmexCardIcon className='w-8 my-auto' />;
      case 'discover':
        return <DiscoverCardIcon className='w-8 my-auto' />
      case 'cashapp':
        return <CashappIcon className='w-8 h-8 my-auto' />
      case 'amazon_pay':
        return <AmazonPayIcon className='w-8 h-6 my-auto' />
      default:
        return <img src="/icons/unknown.svg" alt="Unknown" />;
    }
  };

  // var { paymentMethods } = useGetPaymentMethods(loggedinUid);
  // paymentMethods = (paymentMethods && Array.isArray(paymentMethods)) ? paymentMethods : [];

  // Create a map of paymentMethods with id as key and paymentMethod object as value
  // const paymentMethodsMap: { [id: string]: PaymentMethod } = {};
  // if (paymentMethods && Array.isArray(paymentMethods)){
  // paymentMethods?.forEach((pm: PaymentMethod) => {
  //   if (pm && pm.id) {
  //       paymentMethodsMap[pm.id] = pm;
  //     }
  //   });
  // }

  // const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(
  //   (paymentMethods && paymentMethods.length > 0) ? paymentMethods.find((p: PaymentMethod) => p.id === currentPaymentHistoryList[0]?.payment_method) || paymentMethods[0] : {} as PaymentMethod
  // );

  // const handlePageChange = (page: number) => {
  //   setCurrentPage(page);
  // };

  // const getStatusColor = (status: string) => {
  //   switch (status) {
  //     case 'completed':
  //       return 'text-green-600';
  //     case 'pending':
  //       return 'text-orange-600';
  //     case 'refunded':
  //       return 'text-blue-600';
  //     case 'failed':
  //       return 'text-red-600';
  //     default:
  //       return 'text-gray-600';
  //   }
  // };

  // const getStatusDotColor = (status: string) => {
  //   switch (status) {
  //     case 'completed':
  //       return 'text-green-600';
  //     case 'pending':
  //       return 'text-orange-600';
  //     case 'refunded':
  //       return 'text-blue-600';
  //     case 'failed':
  //       return 'text-red-600';
  //     default:
  //       return 'text-gray-600';
  //   }
  // };

  // const getPaymentMethodIcon = (paymentMethod: string) => {
  //   if (paymentMethod){
  //   switch (paymentMethod.toLowerCase()) {
  //     case 'master card':
  //     case 'mastercard':
  //       return <MasterCardIcon className="w-6 h-6 mr-2" />;
  //       default:
  //         return <div className="w-6 h-6 bg-gray-300 rounded-full mr-2"></div>;
  //     }
  //   }
  //   return <></>
  //   // return <div className="w-6 h-6 bg-gray-300 rounded-full mr-2"></div>;
  // };

  // console.log("paymentMethods: ", paymentMethods)
  // console.log("paymentHistoryList: ", paymentHistoryList)
  // console.log("currentPaymentHistoryList[0]: ", currentPaymentHistoryList ? currentPaymentHistoryList[0]?.payment_method : '')


  // const getCardIcon = (paymentMethod: string) => {
  //   switch (paymentMethod) {
  //     case 'visa':
  //       return <VisaCardIcon className='w-8 my-auto' />;
  //     case 'mastercard':
  //       return <MasterCardIcon className='w-8 my-auto' />;
  //     case 'amex':
  //       return <AmexCardIcon className='w-8 my-auto' />;
  //     case 'discover':
  //       return <DiscoverCardIcon className='w-8 my-auto' />
  //     case 'cashapp':
  //       return <CashappIcon className='w-8 h-8 my-auto' />
  //     case 'amazon_pay':
  //       return <AmazonPayIcon className='w-8 h-6 my-auto' />
  //     default:
  //       return <img src="/icons/unknown.svg" alt="Unknown" />;
  //   }
  // };

  // console.log("paymentHistoryItem: ", paymentHistoryItem)

  return (

              <tr key={paymentHistoryItem.id} className="hover:bg-gray-50">
                {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                  {paymentHistoryItem.user_full_name}
                </td> */}
                {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                  <div className="flex items-center">
                    {paymentHistoryItem.resource_name}
                  </div>
                </td> */}
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                  {/* ${styleThousandCommas(((paymentHistoryItem.total_cost) ? paymentHistoryItem.total_cost  : 0).toFixed(2))} */}
                  ${styleThousandCommas(((paymentHistoryItem.amount) ? (paymentHistoryItem.amount / 100)  : 0).toFixed(2))}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                  <div className="flex items-center">
                    {/* {getPaymentMethodIcon(paymentHistoryItem.payment_method)}
                    {paymentHistoryItem.payment_method} {paymentHistoryItem.cardNumber} */}
                    
                    
               
                       
                    {((paymentHistoryItem.payment_method && paymentHistoryItem.payment_method.card) ? <>
                      <div className='mx-1 my-auto border-[#E9E9E9] border-[1px] p-1 rounded-xl'>
                        {getCardIcon(paymentHistoryItem.payment_method?.card?.brand || '')} 
                      </div>
                      &nbsp;
                      {/* <div className='my-auto'>
                        {capitalizeString(paymentMethod.card?.brand || '')}
                      </div> */}
                      &nbsp;
                      <div className='my-auto '>
                        ***{paymentHistoryItem.payment_method?.card?.last4 || ''}
                      </div>
                      &nbsp;
                      <div className='my-auto'>
                        Exp: {formatDateString(paymentHistoryItem.payment_method?.card?.exp_month || 0, paymentHistoryItem.payment_method?.card?.exp_year || 0)}
                      </div>
                    </> : <></>)}
                        
                      
                    <>
                      {/* <div className='mx-4 my-auto border-[#E9E9E9] border-[1px] p-1 rounded-xl'>
                        {getCardIcon(paymentMethod.card.brand)} 
                      </div>
                      <div className='w-1/4 my-auto'>
                        {capitalizeString(paymentMethod.card.brand)}
                      </div>
                      <div className='w-1/4 my-auto '>
                        ****{paymentMethod.card.last4 || ''}
                      </div>
                      <div className='w-1/4 my-auto'>
                        Expires {formatDateString(paymentMethod.card.exp_month, paymentMethod.card.exp_year)}
                      </div> */}
                    </>
                  </div>
                </td>
                {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                  {paymentHistoryItem.created ? moment(paymentHistoryItem.created).format('MM/DD/YYYY hh:mm A') : '-'}
                </td> */}
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                  {paymentHistoryItem.id.split('_')[1]}
                </td>
                {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                  {paymentHistoryItem.created ? moment.utc(paymentHistoryItem.created).fromNow() : '-'}
                </td> */}
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  <span className={`flex items-center`} style={{ color: getPaymentStatusColor(paymentHistoryItem.status).primaryTextColor }}>
                    <FiberManualRecordIcon 
                      style={{ fontSize: 15 }} 
                    />
                    <span className="ml-1 capitalize">
                      {getPaymentStatusColor(paymentHistoryItem.status).displayText}
                    </span>
                  </span>
                </td>
                {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">
                  <div className="flex justify-center">
                    <button className="w-8 h-8 bg-white rounded-full flex items-center justify-center border border-[#E9E9E9] hover:bg-gray-300">
                      <MoreHorizIcon style={{ fontSize: 18, color: "#555" }} />
                    </button>
                  </div>
                </td> */}
              </tr>
            
  );
};

export default PaymentHistoryRecord;
